// extracted by mini-css-extract-plugin
module.exports = {"banner_img":"courses_banner_img__pOP4_","button_hover":"courses_button_hover__n3TlM","color":"courses_color__BPGzv","img_size":"courses_img_size__AgeMy"};